import React, { useContext, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { FullScreenContext } from "../../../App";
import { clearSelectedCertificationCli, RootState } from "../../../store";

interface Question {
  _id: string;
  submittedAnswer: number | null;
  correct_option_id: number;
}

export default function QuizResult() {
  const { questions, score, unattemptedQuestions, quizzes } = useSelector((state: RootState) => state.quiz);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { handle } = useContext(FullScreenContext);

  const getAnswerStats = (ques: Record<string, any>) => {
    const stats = {
      noOfCorrect: 0,
      noOfIncorrect: 0,
      noOfUnattempted: 0,
    };

    (Object.values(ques) as Question[]).forEach((question) => {
      if (question.submittedAnswer === null) {
        stats.noOfUnattempted++;
      } else if (question.submittedAnswer === question.correct_option_id) {
        stats.noOfCorrect++;
      } else {
        stats.noOfIncorrect++;
      }
    });

    return stats;
  };

  const stats = getAnswerStats(questions);
  const quizName = useMemo(() => {
    const matchedQuiz = (quizzes || []).find((quiz: any) => quiz.quiz_id === id);
    return matchedQuiz?.quiz_name || "Quiz";
  }, [id, quizzes]);

  const handleExit = () => {
    if (handle) {
      handle.exit();
    }
    dispatch(clearSelectedCertificationCli());
    navigate(`/`);
  };

  return (
    <div className="test-end-container">
      <div className="result-header">SCOREBOARD</div>
      <div className="test-end-content">
        <div className="score-card">
          <div className="body-container">
            <div className="test-details">
              <div className="test">Test Name</div>
              <div className="test-name">{quizName}</div>
            </div>
            <div className="current-quiz-report">
              <BodyItem type={"Correct"} count={stats.noOfCorrect} />
              <BodyItem type={"Incorrect"} count={stats.noOfIncorrect} />
              <BodyItem type={"Unattempted"} count={unattemptedQuestions.length} />
            </div>
            <div className="score-tile">Total Score <span style={{ marginLeft: "148px" }}>{score}</span></div>
          </div>
        </div>

        <button onClick={handleExit} className="exit-btn">
          <div>
            <div className="btn-name">
              Home
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}

interface BodyItemProps {
  type: string;
  count: number | string;
}

const BodyItem: React.FC<BodyItemProps> = ({ type, count }) => (
  <div className="text-provider">
    <p className="left-text">{type} </p>
    <p className="right-text">{count}</p>
  </div>
);
